import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Vercel Remote Cache is now free",
  "description": "Free Remote Caching for repositories linked to Vercel",
  "date": "2024/12/20",
  "tag": "web development",
  "ogImage": "/images/blog/free-vercel-remote-cache/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "One of Turborepo's most important features is Remote Caching, a distributed caching layer that ensures your developers and CI never do the same work twice."
  }, {
    "heading": "",
    "content": "As of today, Vercel Remote Cache is now a free, zero-configuration option for any Turborepo linked to Vercel, joining the open-source Remote Caches created by the community as free options for speeding up your development."
  }, {
    "heading": "on-vercel",
    "content": "Commands using turbo on Vercel are automatically configured to use Vercel Remote Cache. Your builds will benefit from Remote Caching with zero-configuration."
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "Create the TURBO_TOKEN and TURBO_TEAM environment variables to authenticate to Vercel Remote Cache with their respective values. Visit our CI provider documentation to learn how to connect to:"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "GitHub Actions"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "GitLab CI"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "CircleCI"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "GitLab CI"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "Travis CI"
  }, {
    "heading": "on-other-continuous-integration-providers",
    "content": "Any other CI provider"
  }, {
    "heading": "on-your-local-machine",
    "content": "To get started locally, run:"
  }, {
    "heading": "more-information",
    "content": "To learn more, visit Vercel's changelog announcement or Vercel Remote Cache documentation."
  }],
  "headings": [{
    "id": "linking-a-repository-to-vercel-remote-cache",
    "content": "Linking a repository to Vercel Remote Cache"
  }, {
    "id": "on-vercel",
    "content": "On Vercel"
  }, {
    "id": "on-other-continuous-integration-providers",
    "content": "On other Continuous Integration providers"
  }, {
    "id": "on-your-local-machine",
    "content": "On your local machine"
  }, {
    "id": "more-information",
    "content": "More information"
  }]
};
export const toc = [{
  depth: 2,
  url: "#linking-a-repository-to-vercel-remote-cache",
  title: _jsx(_Fragment, {
    children: "Linking a repository to Vercel Remote Cache"
  })
}, {
  depth: 3,
  url: "#on-vercel",
  title: _jsx(_Fragment, {
    children: "On Vercel"
  })
}, {
  depth: 3,
  url: "#on-other-continuous-integration-providers",
  title: _jsx(_Fragment, {
    children: "On other Continuous Integration providers"
  })
}, {
  depth: 3,
  url: "#on-your-local-machine",
  title: _jsx(_Fragment, {
    children: "On your local machine"
  })
}, {
  depth: 2,
  url: "#more-information",
  title: _jsx(_Fragment, {
    children: "More information"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Vercel Remote Cache is now free"
    }), "\n", _jsxs(_components.p, {
      children: ["One of Turborepo's most important features is ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), ", a distributed caching layer that ensures your developers and CI never do the same work twice."]
    }), "\n", _jsxs(_components.p, {
      children: ["As of today, ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), " is now a free, zero-configuration option for any Turborepo linked to Vercel, joining the ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching#community-implementations",
        children: "open-source Remote Caches created by the community"
      }), " as free options for speeding up your development."]
    }), "\n", _jsx(_components.h2, {
      id: "linking-a-repository-to-vercel-remote-cache",
      children: "Linking a repository to Vercel Remote Cache"
    }), "\n", _jsx(_components.h3, {
      id: "on-vercel",
      children: "On Vercel"
    }), "\n", _jsxs(_components.p, {
      children: ["Commands using ", _jsx(_components.code, {
        children: "turbo"
      }), " on Vercel are automatically configured to use Vercel Remote Cache. Your builds will benefit from Remote Caching with zero-configuration."]
    }), "\n", _jsx(_components.h3, {
      id: "on-other-continuous-integration-providers",
      children: "On other Continuous Integration providers"
    }), "\n", _jsxs(_components.p, {
      children: ["Create the ", _jsx(_components.code, {
        children: "TURBO_TOKEN"
      }), " and ", _jsx(_components.code, {
        children: "TURBO_TEAM"
      }), " environment variables to authenticate to Vercel Remote Cache with their respective values. Visit ", _jsx(_components.a, {
        href: "/docs/guides/ci-vendors",
        children: "our CI provider documentation"
      }), " to learn how to connect to:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/github-actions",
          children: "GitHub Actions"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/gitlab-ci",
          children: "GitLab CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/circleci",
          children: "CircleCI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/gitlab-ci",
          children: "GitLab CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/travis-ci",
          children: "Travis CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors#general-setup",
          children: "Any other CI provider"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "on-your-local-machine",
      children: "On your local machine"
    }), "\n", _jsx(_components.p, {
      children: "To get started locally, run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "more-information",
      children: "More information"
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more, visit ", _jsx(_components.a, {
        href: "https://vercel.com/changelog/free-vercel-remote-cache",
        children: "Vercel's changelog announcement"
      }), " or ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache documentation"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
